module.exports = __webpack_public_path__ + "static/media/rd-confirm-header.1a16c659.png";